// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__IG6EW","alertIcon":"ConfirmModal_alertIcon__3Pu8b"};